import React, { forwardRef, useMemo, useState } from "react";
import { Notification, NotificationCategory } from "../../../_app/types";
import { TabPanelStyled } from "../StyledAdron";
import { Box, Tab } from "@mui/material";
import { TabContext } from "@mui/lab";
import { useTheme } from "@mui/material/styles";
import NotificationListRender from "./NotificationListRender";
import AdronTypography from "../AdronTypography";
import { TabsStyledV2 } from "../../../_components/TabsStyledV2";

interface Props {
  notifications: Notification[];
}

const NotificationTabs = forwardRef<HTMLDivElement, Props>(({ notifications }, ref) => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState<NotificationCategory>("ALL");

  const handleChange = (event: React.SyntheticEvent, newValue: NotificationCategory) => {
    setActiveTab(newValue);
  };

  const filteredNotifications = useMemo(() => {
    if (activeTab === "ALL") return notifications;
    return notifications.filter((x) => x.type === activeTab);
  }, [activeTab, notifications]);

  return (
    <>
      <TabContext value={activeTab}>
        <Box className="layout">
          <Box
            className="layout-fixed-wrapper"
            sx={{
              borderTopLeftRadius: "12px",
              borderTopRightRadius: "12px",
            }}
          >
            <TabsStyledV2 onChange={handleChange}>
              {["ALL", "INFO", "WARN", "ERROR"].map((category, index) => (
                <Tab
                  key={category + "_" + index}
                  label={category === "WARN" ? "WARNING" : category}
                  value={category}
                  className="adron-tab-button"
                  style={{
                    borderTopRightRadius: 16,
                    borderTopLeftRadius: 16,
                  }}
                />
              ))}
            </TabsStyledV2>
          </Box>

          <Box className="layout-content-wrapper">
            <TabPanelStyled
              value={activeTab}
              style={{
                height: "100%",
                overflowY: "scroll",
                overflowX: "hidden",
                backgroundColor:
                  theme.palette.mode === "dark"
                    ? theme.palette.grey[300]
                    : theme.palette.secondary.light,
              }}
            >
              {notifications.length > 0 ? (
                <NotificationListRender messages={filteredNotifications} />
              ) : (
                <AdronTypography
                  style={{
                    fontWeight: 600,
                    textAlign: "center",
                    marginTop: 15,
                  }}
                  fontSize={20}
                  value={"No data to display"}
                />
              )}
              {activeTab === "ALL" && (
                <div
                  style={{
                    position: "relative",
                    marginBottom: "20px",
                    width: "100px",
                    height: "30px",
                  }}
                  className={"observerRef"}
                  ref={ref}
                />
              )}
            </TabPanelStyled>
          </Box>
        </Box>
      </TabContext>
    </>
  );
});

export default NotificationTabs;
